import moment from "moment";
import StarRating from "../Components/RatingStar";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FcShop } from "react-icons/fc";
import Description from "../Components/Description/Description";
import { FaReply } from "react-icons/fa";
import { BiSolidHide } from "react-icons/bi";
import { FaEye } from "react-icons/fa";


export const FinanceColumns = [
  {
    field: "createdAt", header: "Date",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "createdAt")} className="">
          <p className="w-[6rem]">
            {moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "customer",
    header: "Customer",
    accessor: (row, handleCellClick) => (<div onClick={() => handleCellClick(row?.customer, "user")} className="w-fit">
      {/* <div className="overflow-hidden">
        {row?.customer?.profile_image ? <LazyLoadImage
          src={row?.customer?.profile_image}
          alt="img"
          loading="lazy"
          effect="blur"
          wrapperProps={{
            style: { transitionDelay: ".5s" },
          }}
          className="rounded-full w-20 h-20"
        /> : (<div className="rounded-full w-20 h-20 bg-[#d2d2d2] flex justify-center items-center"><FcShop className="text-[3rem]  text-[#02aabd93]" /></div>)}
      </div> */}
      <p className="w-full capitalize text-nowrap text-center">{row?.customer?.first_name || ""}   {row?.customer?.last_name || ""} </p>
    </div>),

  },

  {
    field: "rating", header: "Rating",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-[6rem]">
            <StarRating stars={row?.rating} />
          </p>
        </div>
      </>
    ),
  },
  {
    field: "review", header: "Review",
    accessor: (row, handleCellClick) => {

      return (
        <>
          <div onClick={() => handleCellClick(row, "review")} className="w-[30rem] max-w-[40rem] ">
            <Description description={row?.review || ""} />
          </div>
        </>
      )
    },
  },
  {
    field: "reply",
    header: "Reply Status",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "reply")} className="w-[20rem] max-w-[20rem]">
          {row?.reply ? (
            <div className="bg-gray-100 p-2 rounded">
              <Description description={row.reply?.text} length={40} />
            </div>
          ) : (
            <span className="text-gray-400">No reply yet</span>
          )}
        </div>
      </>
    ),
  },
  {
    field: "actions",
    header: "Actions",
    accessor: (row, handleCellClick) => (
      <div className="flex ml-10 gap-2">
        <button
          className=""
          onClick={(e) => {
            e.stopPropagation();
            handleCellClick(row, "replyAction");
          }}
          title="Reply"
        >
          <FaReply />
        </button>
        {/* <button
          className=""
          onClick={(e) => {
            e.stopPropagation();
            handleCellClick(row, "hideAction");
          }}
          title="Hide Review"
        >
          <BiSolidHide />
        </button> */}
      </div>
    ),
  }
];


export const FinancesearchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const Financefilters = [
  {
    filterType: "Rating",
    inputName: "rating",
    options: [
      {
        name: "5",
        code: "5",
      },
      {
        name: "4",
        code: "4",
      },
      {
        name: "3",
        code: "3",
      },
      {
        name: "2",
        code: "2",
      },
      {
        name: "1",
        code: "1",
      },

    ],
  },

];


export const FinancecanlenderFilter = {
  filterType: "Review Date",
  inputName: "createdAt",
  maxDate: new Date()
}

// export const ProductColumns = [
//   { field: "createdAt", header: "Date",
//     accessor: (row,handleCellClick) => (
//       <>
//         <div  onClick={()=>handleCellClick(row,"createdAt")}  className="">          
//           <p className="w-[6rem]">
//             {moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}
//           </p>
//         </div>
//       </>
//     ),
//    },
//    { 

//     field: "user", 
//     header: "Customer",
//     accessor: (row,handleCellClick) => (<div onClick={()=>handleCellClick(row?.user,"user")} className="w-fit">
//     <div  className="overflow-hidden">
//    {row?.user?.profile_image? <LazyLoadImage
//       src={row?.user?.profile_image}
//       alt="img"
//       loading="lazy"
//       effect="blur"
//       wrapperProps={{
//         style: { transitionDelay: ".5s" },
//       }}
//       className="rounded-full w-20 h-20"
//       />:(<div className="rounded-full w-20 h-20 bg-[#d2d2d2] flex justify-center items-center"><FcShop  className="text-[3rem]  text-[#02aabd93]"/></div>)}
//       </div>
//     <p className="w-full text-nowrap text-center">{row?.user?.first_name || ""}   {row?.user?.last_name || ""} </p>
//     </div>),

//   },
//   { field: "product_detail", header: "Product Details",
//     accessor: (row,handleCellClick) => (
//       <>
//         <div  onClick={()=>handleCellClick(row,"product_detail")} className="cursor-pointer text-blue-600 hover:text-blue-800">          
//           <p className="w-[6rem] line-clamp-2">
//             {row?.product_detail?.name || ""} 
//           </p>
//         </div>
//       </>
//     ),
//    },
//   { field: "rating", header: "Rating",
//     accessor: (row,handleCellClick) => (
//       <>
//         <div  onClick={()=>handleCellClick(row,"user")}  className="">          
//           <p className="w-[6rem]">
//             <StarRating stars={row?.rating}/>   
//           </p>
//         </div>
//       </>
//     ),
//    },
//   { field: "review", header: "Review",
//     accessor: (row,handleCellClick) => {

//       return (
//         <>
//           <div  onClick={()=>handleCellClick(row,"review")}  className="w-[6rem] h-5 line-clamp-2">          
//             <p className="w-[6rem]">
//               {row?.review || ""}
//             </p>
//           </div>
//         </>
//       )
//     },
//    },
//   // { field: "images", header: "Images",
//   //   accessor: (row,handleCellClick) => (
//   //     <>
//   //       <div  onClick={()=>handleCellClick(row,"images")}  >    
//   //       <ImageGallery 
//   //       images={row?.images?row?.images.map((img,i)=>{
//   //         const galleryData={
//   //           itemImageSrc: img,
//   //           thumbnailImageSrc: img,
//   //           alt: img,
//   //           title: img
//   //         }
//   //         return galleryData
//   //       }):[]}

//   //       sx={{maxWidth:"20%"}}
//   //       />
//   //       </div>
//   //     </>
//   //   ),
//   //  },

// ];


export const ProductColumns = [
  {
    field: "createdAt",
    header: "Date",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "createdAt")} className="">
          <p className="w-[6rem]">
            {moment(row?.createdAt).utc().format("DD-MM-YYYY")}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "user",
    header: "Customer",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-full">
            {row?.user?.first_name || ""} {row?.user?.last_name || ""}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "product_detail",
    header: "Product Details",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "product_detail")}
          className="cursor-pointer text-green600 hover:text-green800  w-[15rem] max-w-[20rem] "
        >
          <Description description={row?.product_detail?.name || ""} length={10} />
        </div>
      </>
    ),
  },
  {
    field: "rating",
    header: "Rating",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-[6rem]">
            <StarRating stars={row?.rating} />
          </p>
        </div>
      </>
    ),
  },
  {
    field: "review",
    header: "Review",
    accessor: (row, handleCellClick) => {
      return (
        <>
          <div
            onClick={() => handleCellClick(row, "review")}
            className="w-[20rem] max-w-[20rem]"
          >
            <Description description={row?.review || ""} length={40} />
          </div>
        </>
      );
    },
  },
  {
    field: "vendor_reply",
    header: "Reply Status",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "vendor_reply")} className="w-[20rem] max-w-[20rem]">
          {row?.vendor_reply ? (
            <div className="bg-gray-100 p-2 rounded">
              <Description description={row.vendor_reply} length={40} />
            </div>
          ) : (
            <span className="text-gray-400">No reply yet</span>
          )}
        </div>
      </>
    ),
  },
  {
    field: "actions",
    header: "Actions",
    accessor: (row, handleCellClick) => {
      console.log("row ", row)
      return (
        <div className="flex ml-10 gap-2">
          <button
            className=""
            onClick={(e) => {
              e.stopPropagation();
              handleCellClick(row, row?.is_reply_hide === false ? "hideAction" : "showAction");
            }}
            title={row?.is_reply_hide === false ? "Hide Review" : "Show Review"}
          >
            {row?.is_reply_hide === false ? <BiSolidHide /> : <FaEye />}
          </button>
        </div>
      )
    }
  }
];

export const ProductsearchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const Productfilters = [
  {
    filterType: "Rating",
    inputName: "rating",
    options: [
      {
        name: "5",
        code: "5",
      },
      {
        name: "4",
        code: "4",
      },
      {
        name: "3",
        code: "3",
      },
      {
        name: "2",
        code: "2",
      },
      {
        name: "1",
        code: "1",
      },
    ],
  },
  {
    filterType: "Reply Status",
    inputName: "replyStatus",
    options: [
      {
        name: "With Reply",
        code: "With Reply",
      },
      {
        name: "Without Reply",
        code: "Without Reply",
      },
    ],
  },
];


export const ProductcanlenderFilter = {
  filterType: "Review Date",
  inputName: "createdAt",
  maxDate: new Date()
}
